





















import Vue from 'vue';
import TMAlertComponent from '@/components/TMAlert.vue';
import TMAuth from './tools/TMAuth';
import TMAlert from './tools/models/TMAlert';
import User from './tools/models/User';

export default Vue.extend({
  name: 'App',
  components: {
    'tm-alert': TMAlertComponent,
  },
  data: () => ({
    //
  }),
  computed: {
    bgClasses(): string {
      const routeName = this.$route.name;

      return routeName !== 'Login' && routeName !== 'Cadastro' ? 'main-bg blur-bg' : 'main-bg';
    },
    user(): User {
      return this.$store.getters.user;
    },
  },
  methods: {
    initialAlert(): void {
      const routeName = this.$route.name;

      if (routeName === 'Login' || routeName === 'Home') {
        this.$store.dispatch(
          'setAlert',
          new TMAlert({
            title: 'Nortox',
            message:
              'Programa exclusivo para clientes finais dos produtos Nortox via distribuição e venda direta.',
            state: true,
          }),
        );
      }
    },
  },
  created(): void {
    this.initialAlert();
    this.$store.dispatch('getUserFromApi').then(() => {
      if (this.user.id === -1) {
        TMAuth.logout(this.$router);
      }
    });
  },
});
